import { Dialog, DialogFooter, Dropdown, FormField } from "@/ds";
import { UserContactCard } from "@/shared/components/user-contact-card";
import {
  EDIT_USER_TITLE,
  ROLE_LABEL,
  ROLE_PLACEHOLDER,
  ROLE_SEARCH_PLACEHOLDER,
  ROLES_EMPTY_FILTER_MESSAGE,
} from "./edit-user-dialog.constants";
import styles from "./edit-user-dialog.module.scss";
import type { EditUserDialogViewModel } from "./types-edit-user-dialog";

/** Modal Editar Usuário (Figma 5033:103820): identidade em cartão e o campo Perfil obrigatório. */
export function EditUserDialogView({
  formId,
  contato,
  perfil,
  isSubmitting,
  enviar,
  cancelar,
}: EditUserDialogViewModel) {
  return (
    <Dialog
      visible
      size="sm"
      className={styles.dialog}
      header={EDIT_USER_TITLE}
      onHide={cancelar}
      locked={isSubmitting}
      footer={
        <DialogFooter
          cancelVariant="text"
          cancelTestId="edit-user-cancel"
          confirmTestId="edit-user-save"
          confirmLabel="Salvar"
          formId={formId}
          loading={isSubmitting}
          locked={isSubmitting}
          onCancel={cancelar}
        />
      }
      data-testid="edit-user-dialog"
    >
      <form id={formId} className={styles.form} onSubmit={enviar} noValidate>
        <UserContactCard {...contato} />

        <FormField.Root required error={perfil.error} disabled={perfil.isDisabled}>
          <FormField.Label>{ROLE_LABEL}</FormField.Label>
          <FormField.Control>
            <Dropdown
              value={perfil.value}
              options={perfil.options}
              optionLabel="label"
              optionValue="value"
              placeholder={ROLE_PLACEHOLDER}
              filter
              filterBy="label"
              filterPlaceholder={ROLE_SEARCH_PLACEHOLDER}
              emptyFilterMessage={ROLES_EMPTY_FILTER_MESSAGE}
              emptyMessage={perfil.emptyMessage}
              onChange={(event) => perfil.escolher((event.value as string | null) ?? "")}
              data-testid="edit-user-role"
            />
          </FormField.Control>
          <FormField.Error data-testid="edit-user-role-error" />
        </FormField.Root>
      </form>
    </Dialog>
  );
}
